import { useState, useContext, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import AnalyticsHeader from "./AnalyticsHeader";
import DisplayScorePercent from "./DisplayScorePercent";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";

let matchFound = false;
function AnalyticsLanding() {
	const [errorValue, setErrorValue] = useState([]);
	const [facilityAnalytics, setFacilityAnalytics] = useState({});
	const [facilityAnalyticsFound, setFacilityAnalyticsFound] = useState(false);
	const [farmAnalytics, setFarmAnalytics] = useState({});
	const [farmAnalyticsFound, setFarmAnalyticsFound] = useState(false);
	const [supplierAnalytics, setSupplierAnalytics] = useState({});
	const [supplierAnalyticsFound, setSupplierAnalyticsFound] = useState(false);
	const [showScorePopup, setShowScorePopup] = useState(false);
	const { t } = useTranslation();
	const [popupAssessment, setPopupAssessment] = useState({});
	const [farmCountArr, setFarmCountArr] = useState([]);
	const [facilityCountArr, setFacilityCountArr] = useState([]);
	const [supplierCountArr, setSupplierCountArr] = useState([]);
	const [dataFound, setDataFound] = useState(false);
	const [delegates, setDelegates] = useState([]);
	const [runCount, setRunCount] = useState(0);
	const navigate = useNavigate();
	const userCtx = useContext(UserContext);

	useEffect(() => {
		fetchFacilityAnalytics();
		fetchFarmAnalytics();
		//fetchSupplierAnalytics();
		//fetchDelegates();
	}, []);

	useEffect(() => {
		if (runCount >= 3 && !dataFound && delegates && delegates.length > 0) {
			navigate("/pages/supplierAnalyticsChart", { state: { directLanding: "true", delegates: delegates } });
		}
	}, [runCount, delegates]);


	function fetchFacilityAnalytics() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetFacilityAnalytics", "/Service/QuestionService/GetFacilityAnalytics", requestOptions, getFacilityAnalyticsSuccess, getFacilityAnalyticsFail, getFacilityAnalyticsComplete);
		} catch (error) {
			//console.log(error.message);
			setErrorValue([error.message]);
		}
	}

	function getFacilityAnalyticsFail(redirect, getFacilityAnalyticsComplete) {
		//setErrorValue([t("error.getAnalyticsFailed")]);
		getFacilityAnalyticsComplete();
	}
	function getFacilityAnalyticsSuccess(responseData, getFacilityAnalyticsComplete) {
		let facilityAnalyticsResponse;
		if (responseData) {
			facilityAnalyticsResponse = responseData.getFacilityAnalyticsResponse;
			if (facilityAnalyticsResponse && facilityAnalyticsResponse.errorCode === "0") {
				setFacilityAnalytics(facilityAnalyticsResponse);
				setFacilityAnalyticsFound(true);
				setFacilityCounts(facilityAnalyticsResponse);
			} else if (facilityAnalyticsResponse) {
				//setErrorValue([t("error.error") + " " + facilityAnalyticsResponse.errorMessage]);
				console.log(t("error.error") + " " + facilityAnalyticsResponse.errorMessage);
			}
		}
		getFacilityAnalyticsComplete();
	}

	function getFacilityAnalyticsComplete() {
		setRunCount(runCount => runCount + 1);
	}

	function setFacilityCounts(facilityAnalyticsResponse) {
		let annualAssessCount = 0;
		let productionAssessCount = 0;
		let productAssessCount = 0;
		let finishedProductAssessCount = 0;
		let correctiveActionsCount = 0;
		let facilityCountObj = {
			facilityCount: 0,
			annualAssessmentsCount: 0,
			productionAssessmentsCount: 0,
			productAssessmentsCount: 0,
			finishedProductAssessmentsCount: 0,
			correctiveActionCount: 0,
		}
		let facilityCountArray = [];

		if (facilityAnalyticsResponse && facilityAnalyticsResponse.facilityAssessments && facilityAnalyticsResponse.facilityAssessments.length > 0) {
			setDataFound(true);
			facilityAnalyticsResponse.facilityAssessments.map((eachFacilityAssment, index) => {
				if (eachFacilityAssment && eachFacilityAssment.facilities && eachFacilityAssment.facilities.length > 0) {
					facilityCountObj = {
						facilityCount: eachFacilityAssment.facilities.length,
						annualAssessmentsCount: 0,
						productionAssessmentsCount: 0,
						productAssessmentsCount: 0,
						finishedProductAssessmentsCount: 0,
						correctiveActionCount: 0,
					}
					annualAssessCount = 0;
					productionAssessCount = 0;
					productAssessCount = 0;
					finishedProductAssessCount = 0;
					correctiveActionsCount = 0;
					eachFacilityAssment.facilities.map((eachFacility) => {
						annualAssessCount += eachFacility.annualAssessments.questionnaire.length;
						productionAssessCount += eachFacility.productionAssessments.questionnaire.length;
						productAssessCount += eachFacility.incomingProductAssessments.questionnaire.length;
						finishedProductAssessCount += eachFacility.finishedProductAssessments.questionnaire.length;
						correctiveActionsCount += eachFacility.correctiveActions.questionnaire.length;
					});
					facilityCountObj.annualAssessmentsCount = annualAssessCount;
					facilityCountObj.productionAssessmentsCount = productionAssessCount;
					facilityCountObj.incomingProductAssessmentsCount = productAssessCount;
					facilityCountObj.finishedProductAssessmentsCount = finishedProductAssessCount;
					facilityCountObj.correctiveActionCount = correctiveActionsCount;
					facilityCountArray.push(facilityCountObj);
					//alert("index: "+index+ " "+ JSON.stringify(facilityCountArray) );
				}
			});
		}
		setFacilityCountArr(facilityCountArray);
	}
	const displayScorePercent = (assessments) => {
		setPopupAssessment(assessments);
		setShowScorePopup(true);
	}

	function resetAssessment() {
		setPopupAssessment({});
	}

	function fetchFarmAnalytics() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetFarmAnalytics", "/Service/QuestionService/GetFarmAnalytics", requestOptions, getFarmAnalyticsSuccess, getFarmAnalyticsFail, getFarmAnalyticsComplete);
		} catch (error) {
			//console.log(error.message);
			setErrorValue([error.message]);
		}
	}
	function getFarmAnalyticsComplete() {
		setRunCount(runCount => runCount + 1);
	}
	function getFarmAnalyticsFail(redirect, getFarmAnalyticsComplete) {
		//setErrorValue([t("error.getAnalyticsFailed")]);
		getFarmAnalyticsComplete();
	}
	function getFarmAnalyticsSuccess(responseData, getFarmAnalyticsComplete) {
		let farmAnalyticsResponse;
		if (responseData) {
			farmAnalyticsResponse = responseData.getFarmAnalyticsResponse;
			if (farmAnalyticsResponse && farmAnalyticsResponse.errorCode === "0") {
				setFarmAnalytics(farmAnalyticsResponse);
				setFarmAnalyticsFound(true);
				setFarmCounts(farmAnalyticsResponse);
			} else if (farmAnalyticsResponse) {
				//setErrorValue([t("error.error") + " " + farmAnalyticsResponse.errorMessage]);
				console.log(t("error.error") + " " + farmAnalyticsResponse.errorMessage);
			}
		}
		getFarmAnalyticsComplete();
	}
	function setFarmCounts(farmAnalyticsResponse) {
		let farmAnnualAssessCount = 0;
		let harvestAssessCount = 0;
		let farmProductAssessCount = 0;
		let farmCorrectiveCount = 0;
		let farmCountObj = {
			growerCount: 0,
			farmAnnualAssessmentsCount: 0,
			harvestAssessmentsCount: 0,
			farmProductAssessmentsCount: 0,
			farmCorrectiveActionCount: 0,
		}
		let farmCountArray = [];
		if (farmAnalyticsResponse && farmAnalyticsResponse.farms && farmAnalyticsResponse.farms.length > 0) {
			setDataFound(true);
			farmAnalyticsResponse.farms.map((eachFarmAssment, index) => {
				if (eachFarmAssment && eachFarmAssment.growers && eachFarmAssment.growers.length > 0) {
					farmCountObj = {
						growerCount: eachFarmAssment.growers.length,
						farmAnnualAssessmentsCount: 0,
						harvestAssessmentsCount: 0,
						farmProductAssessmentsCount: 0,
						farmCorrectiveActionCount: 0,
					}
					farmAnnualAssessCount = 0;
					harvestAssessCount = 0;
					farmProductAssessCount = 0;
					farmCorrectiveCount = 0;
					eachFarmAssment.growers.map((eachFarm) => {
						farmAnnualAssessCount += eachFarm.annualAssessments.questionnaire.length;
						harvestAssessCount += eachFarm.harvestAssessments.questionnaire.length;
						farmProductAssessCount += eachFarm.incomingProductAssessments.questionnaire.length;
						farmCorrectiveCount += eachFarm.correctiveActions.questionnaire.length;
					});

					farmCountObj.farmAnnualAssessmentsCount = farmAnnualAssessCount;
					farmCountObj.harvestAssessmentsCount = harvestAssessCount;
					farmCountObj.farmProductAssessmentsCount = farmProductAssessCount;
					farmCountObj.farmCorrectiveActionCount = farmCorrectiveCount;
					farmCountArray.push(farmCountObj);
					//alert("index: "+index+ " "+ JSON.stringify(farmCountArray) );
				}
			});
		}
		setFarmCountArr(farmCountArray);
	}
	function fetchDelegates() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", 
								   companyId: userCtx.userCompanyId,
								   loginId: userCtx.loggedInUserId,
								   getAll: false}),
		};
		try {
			FetchUtil.fetchAPI("MGetDelegates", "/Service/CompanyService/GetDelegates", requestOptions, getDelegatesSuccess, getDelegatesFail);
		} catch (error) {
			//console.log(error.message);
			setErrorValue([error.message]);
		}
	}

	function getDelegatesFail(redirect) {
		setDelegates([]);
		//setErrorValue([t("error.partnerDelegateNotRetrieved")]);
		console.log(t("error.partnerDelegateNotRetrieved"));
	}
	function getDelegatesSuccess(responseData) {
		let delegatesResponse;
		if (responseData) {
			delegatesResponse = responseData.getDelegatesResponse;
			if (delegatesResponse && delegatesResponse.errorCode === "0") {
				if (delegatesResponse.delegates) {
					setDelegates([...delegatesResponse.delegates]);
				} else {
					setDelegates([]);
					//setErrorValue([t("error.partnerDelegateNotRetrieved")]);
					console.log(t("error.partnerDelegateNotRetrieved"));
				}
			} else if (delegatesResponse) {
				setDelegates([]);
				//setErrorValue([t("error.error") + " " + delegatesResponse.errorMessage]);
				console.log(t("error.error") + " " + delegatesResponse.errorMessage);
			}
		}
	}
	function fetchSupplierAnalytics() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetSupplierAnalytics", "/Service/QuestionService/GetSupplierAnalytics", requestOptions, getSupplierAnalyticsSuccess, getSupplierAnalyticsFail, getSupplierAnalyticsComplete);
		} catch (error) {
			//console.log(error.message);
			setErrorValue([error.message]);
		}
	}
	function getSupplierAnalyticsComplete() {
		setRunCount(runCount => runCount + 1);
	}
	function getSupplierAnalyticsFail(redirect, getSupplierAnalyticsComplete) {
		//setErrorValue([t("error.getAnalyticsFailed")]);
		getSupplierAnalyticsComplete();
	}
	function getSupplierAnalyticsSuccess(responseData, getSupplierAnalyticsComplete) {
		let supplierAnalyticsResponse;
		if (responseData) {
			supplierAnalyticsResponse = responseData.getSupplierAnalyticsResponse;
			if (supplierAnalyticsResponse && supplierAnalyticsResponse.errorCode === "0") {
				setSupplierAnalytics(supplierAnalyticsResponse);
				setSupplierAnalyticsFound(true);
				setSupplierCounts(supplierAnalyticsResponse);
			} else if (supplierAnalyticsResponse) {
				//setErrorValue([t("error.error") + " " + supplierAnalyticsResponse.errorMessage]);
				console.log(t("error.error") + " " + supplierAnalyticsResponse.errorMessage);
			}
		}
		getSupplierAnalyticsComplete();
	}
	function setSupplierCounts(supplierAnalyticsResponse) {
		let farmAnnualAssessCount = 0;
		let facilityAnnualAssessCount = 0;
		let shipmentAssessCount = 0;
		let finishedProductAssessCount = 0;
		let correctiveActionsCount = 0;
		let supplierCountObj = {
			supplierCount: 0,
			farmAnnualAssessCount: 0,
			facilityAnnualAssessCount: 0,
			shipmentAssessCount: 0,
			finishedProductAssessmentsCount: 0,
			correctiveActionCount: 0,
		}

		if (supplierAnalyticsResponse && supplierAnalyticsResponse.supplierAssessments && supplierAnalyticsResponse.supplierAssessments.length > 0) {
			setDataFound(true);
			supplierAnalyticsResponse.supplierAssessments.map((eachSupplierAssment, index) => {
				if (eachSupplierAssment && eachSupplierAssment.suppliers && eachSupplierAssment.suppliers.length > 0) {
					supplierCountObj = {
						supplierCount: eachSupplierAssment.suppliers.length,
						farmAnnualAssessCount: 0,
						facilityAnnualAssessCount: 0,
						shipmentAssessCount: 0,
						finishedProductAssessmentsCount: 0,
						correctiveActionCount: 0,
					}
					farmAnnualAssessCount = 0;
					facilityAnnualAssessCount = 0;
					shipmentAssessCount = 0;
					finishedProductAssessCount = 0;
					correctiveActionsCount = 0;
					eachSupplierAssment.suppliers.map((eachSupplier) => {
						farmAnnualAssessCount += eachSupplier.farmAnnualAssessments.questionnaire.length;
						facilityAnnualAssessCount += eachSupplier.facilityAnnualAssessments.questionnaire.length;
						shipmentAssessCount += eachSupplier.shipmentAssessments.questionnaire.length;
						finishedProductAssessCount += eachSupplier.finishedProductAssessments.questionnaire.length;
						correctiveActionsCount += eachFacility.correctiveActions.questionnaire.length;
					});
					supplierCountObj.farmAnnualAssessCount = farmAnnualAssessCount;
					supplierCountObj.facilityAnnualAssessCount = facilityAnnualAssessCount;
					supplierCountObj.shipmentAssessCount = shipmentAssessCount;
					supplierCountObj.finishedProductAssessmentsCount = finishedProductAssessCount;
					supplierCountObj.correctiveActionCount = correctiveActionsCount;
					supplierCountObj.push(facilityCountObj);
					//alert("index: "+index+ " "+ JSON.stringify(facilityCountArray) );
				}
			});
		}
		setSupplierCountArr(supplierCountObj);
	}
	const Box = ({ id, className, children }) => (
		<div id={id} className={className}>
			<span style={{ color: "white" }} >{children}</span>
		</div>
	);
	function handleClose() {
		setShowScorePopup(false);
		resetAssessment();
	}
	const onClickNext = (event) => {
		navigate("/pages/supplierAnalyticsChart", { state: { directLanding: "false", delegates: delegates } });
	}

	return (
		<div className="container-fluid">
			<AnalyticsHeader />
			<div className={"container-fluid container_list viewh-85 qbg"}>
				<div className="row">
					<div className="col">
						<div
							id="inerrorMessage"
							className={
								(errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
							}
						>
							{(errorValue && errorValue.length > 0) ?
								(
									errorValue.map((errorData) => (
										<p className="message-line">{errorData}</p>
									))
								) : ""}
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col">
						<div id="placeholder_1" className="placeholder-pg"></div>
					</div>
				</div>
				{(facilityAnalyticsFound && facilityAnalytics && facilityAnalytics.facilityAssessments && facilityAnalytics.facilityAssessments.length > 0) ?
					facilityAnalytics.facilityAssessments.map((eachFacilityAssessment, factAssesindx) => {
						matchFound = false;
						//alert("factAssesindx : " +factAssesindx + " matchFound : "+matchFound + " facilityCountArr.length : "+facilityCountArr.length);
						return (<>
							<div className="row">
								<div className="col text-start">
									<span style={{ fontWeight: "bold", fontSize: "18px" }}>{eachFacilityAssessment.companyName + ", "+ eachFacilityAssessment.countryName}</span>
								</div>
							</div>
							<div className="row" >
								<div className="row-with-indicator">
								</div>
							</div>
							<div className="row">
								<div className="col text-start padd-tb10">
									<span style={{ fontWeight: "bold", fontSize: "15px" }}>{t("header.supply-chain")} </span>
								</div>
							</div>
							{facilityCountArr.length > 0 ?
								facilityCountArr.map((eachFacilityCount, factCountIndex) => {
									if (!matchFound) {
										if (factCountIndex === factAssesindx) {
											matchFound = true;
										}
										//alert("factAssesindx : " +factAssesindx + " factCountIndex : "+factCountIndex+ " matchFound : "+matchFound );
										if (matchFound) {
											return (
												<>
													<div className="row">
														<div className="col">
															<div className="box-container">
																<Box id="box1" className="box box-content1">{eachFacilityCount.facilityCount}<br></br> {t("page.facility")}</Box>
																<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																<Box id="box2" className="box box-content1">{eachFacilityCount.annualAssessmentsCount}<br></br> {t("page.facility.annual.assessments")}</Box>
																<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																<Box id="box3" className="box box-content1">{eachFacilityCount.productionAssessmentsCount}<br></br> {t("page.prod.assess")}</Box>
																<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																<Box id="box4" className="box box-content1">{eachFacilityCount.incomingProductAssessmentsCount}<br></br> {t("page.inc.assess")}</Box>
																<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																<Box id="box5" className="box box-content1">{eachFacilityCount.finishedProductAssessmentsCount}<br></br> {t("page.finished.product.assessments")}</Box>
																<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																<Box id="box6" className="box box-content1">{eachFacilityCount.correctiveActionCount}<br></br> {t("page.corr.action")}</Box>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="row-with-indicator padd-tb10">
														</div>
													</div>
													<div className="row" >
														<div className="row-with-indicator">
														</div>
													</div>
													{eachFacilityAssessment.facilities.map(eachFacility => (
														<div className="row padd-t10">
															<div className="col padd-0"><span style={{ fontSize: "18px" }} >{eachFacility.facilityName}</span></div>
															{(eachFacility.annualAssessments.scoreToDisplay === "H") ?
																<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFacility.annualAssessments)} onClick={() => displayScorePercent(eachFacility.annualAssessments)} ></i></div> :
																(eachFacility.annualAssessments.scoreToDisplay === "M") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFacility.annualAssessments)} onClick={() => displayScorePercent(eachFacility.annualAssessments)} ></i></div> :
																	(eachFacility.annualAssessments.scoreToDisplay === "L") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFacility.annualAssessments)} onClick={() => displayScorePercent(eachFacility.annualAssessments)} ></i></div> : <div className="col" />
															}
															{(eachFacility.productionAssessments.scoreToDisplay === "H") ?
																<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFacility.productionAssessments)} onClick={() => displayScorePercent(eachFacility.productionAssessments)} ></i></div> :
																(eachFacility.productionAssessments.scoreToDisplay === "M") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFacility.productionAssessments)} onClick={() => displayScorePercent(eachFacility.productionAssessments)} ></i></div> :
																	(eachFacility.productionAssessments.scoreToDisplay === "L") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFacility.productionAssessments)} onClick={() => displayScorePercent(eachFacility.productionAssessments)} ></i></div> : <div className="col" />
															}
															{(eachFacility.incomingProductAssessments.scoreToDisplay === "H") ?
																<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFacility.incomingProductAssessments)} onClick={() => displayScorePercent(eachFacility.incomingProductAssessments)} ></i></div> :
																(eachFacility.incomingProductAssessments.scoreToDisplay === "M") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFacility.incomingProductAssessments)} onClick={() => displayScorePercent(eachFacility.incomingProductAssessments)} ></i></div> :
																	(eachFacility.incomingProductAssessments.scoreToDisplay === "L") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFacility.incomingProductAssessments)} onClick={() => displayScorePercent(eachFacility.incomingProductAssessments)} ></i></div> : <div className="col" />
															}
															{(eachFacility.finishedProductAssessments.scoreToDisplay === "H") ?
																<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFacility.finishedProductAssessments)} onClick={() => displayScorePercent(eachFacility.finishedProductAssessments)} ></i></div> :
																(eachFacility.finishedProductAssessments.scoreToDisplay === "M") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFacility.finishedProductAssessments)} onClick={() => displayScorePercent(eachFacility.finishedProductAssessments)} ></i></div> :
																	(eachFacility.finishedProductAssessments.scoreToDisplay === "L") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFacility.finishedProductAssessments)} onClick={() => displayScorePercent(eachFacility.finishedProductAssessments)} ></i></div> : <div className="col" />
															}
															{(eachFacility.correctiveActions.scoreToDisplay === "H") ?
																<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFacility.correctiveActions)} onClick={() => displayScorePercent(eachFacility.correctiveActions)} ></i></div> :
																(eachFacility.correctiveActions.scoreToDisplay === "M") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFacility.correctiveActions)} onClick={() => displayScorePercent(eachFacility.correctiveActions)} ></i></div> :
																	(eachFacility.correctiveActions.scoreToDisplay === "L") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFacility.correctiveActions)} onClick={() => displayScorePercent(eachFacility.correctiveActions)} ></i></div> : <div className="col" />
															}
														</div>
													))}

												</>
											)
										}
									}
								}) : null}
							<br />
						</>);
					}) : <> </>
				}
				<br />
				<br />
				{(farmAnalyticsFound && farmAnalytics && farmAnalytics.farms && farmAnalytics.farms.length > 0) ?
					farmAnalytics.farms.map((eachFarmAssessment, farmAssessIndx) => {
						matchFound = false;
						//alert("farmAssessIndx : " +farmAssessIndx + " matchFound : "+matchFound + " farmCountArr.length : "+farmCountArr.length);
						return (
							<>
								<div className="row">
									<div className="col text-start">
										<span style={{ fontWeight: "bold", fontSize: "18px" }}>{t("page.company.name")} : </span>{eachFarmAssessment.companyName+ ", "+ eachFarmAssessment.countryName}
										<br />
										<span style={{ fontWeight: "bold", fontSize: "18px" }}>{t("page.facility")} : </span>{eachFarmAssessment.facilityName}
									</div>
								</div>
								<div className="row" >
									<div className="row-with-indicator">
									</div>
								</div>
								<div className="row">
									<div className="col text-start padd-tb10">
										<span style={{ fontWeight: "bold", fontSize: "15px" }}>{t("header.supply-chain")} </span>
									</div>
								</div>
								{farmCountArr.length > 0 ?
									farmCountArr.map((eachFarmCount, farmCountIndex) => {
										if (!matchFound) {
											if (farmCountIndex === farmAssessIndx) {
												matchFound = true;
											}
											if (matchFound) {
												return (
													<>
														<div className="row">
															<div className="col">
																<div className="box-container">
																	<Box id="box7" className="box box-content1">{eachFarmCount.growerCount}<br></br> {t("page.grower")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box8" className="box box-content1">{eachFarmCount.farmAnnualAssessmentsCount}<br></br> {t("page.farm.annual.assessments")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box9" className="box box-content1">{eachFarmCount.harvestAssessmentsCount}<br></br> {t("page.harvest.assess")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box10" className="box box-content1">{eachFarmCount.farmProductAssessmentsCount}<br></br> {t("page.inc.assess")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box11" className="box box-content1">{eachFarmCount.farmProductAssessmentsCount}<br></br> {t("page.corr.action")}</Box>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="row-with-indicator padd-tb10">
															</div>
														</div>
														<div className="row" >
															<div className="row-with-indicator">
															</div>
														</div>
														{eachFarmAssessment.growers.map(eachFarm => (
															<div className="row padd-t10">
																<div className="col">
																	<span style={{ fontSize: "18px" }}>{eachFarm.companyName +", "+ eachFarm.countryName}</span>
																</div>
																{(eachFarm.annualAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFarm.annualAssessments)} onClick={() => displayScorePercent(eachFarm.annualAssessments)} ></i></div> :
																	(eachFarm.annualAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFarm.annualAssessments)} onClick={() => displayScorePercent(eachFarm.annualAssessments)} ></i></div> :
																		(eachFarm.annualAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFarm.annualAssessments)} onClick={() => displayScorePercent(eachFarm.annualAssessments)} ></i></div> : <div className="col" />
																}
																{(eachFarm.harvestAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFarm.harvestAssessments)} onClick={() => displayScorePercent(eachFarm.harvestAssessments)} ></i></div> :
																	(eachFarm.harvestAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFarm.harvestAssessments)} onClick={() => displayScorePercent(eachFarm.harvestAssessments)} ></i></div> :
																		(eachFarm.harvestAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFarm.harvestAssessments)} onClick={() => displayScorePercent(eachFarm.harvestAssessments)} ></i></div> : <div className="col" />
																}
																{(eachFarm.incomingProductAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFarm.incomingProductAssessments)} onClick={() => displayScorePercent(eachFarm.incomingProductAssessments)} ></i></div> :
																	(eachFarm.incomingProductAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFarm.incomingProductAssessments)} onClick={() => displayScorePercent(eachFarm.incomingProductAssessments)} ></i></div> :
																		(eachFarm.incomingProductAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFarm.incomingProductAssessments)} onClick={() => displayScorePercent(eachFarm.incomingProductAssessments)} ></i></div> : <div className="col" />
																}
																{(eachFarm.correctiveActions.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachFarm.correctiveActions)} onClick={() => displayScorePercent(eachFarm.correctiveActions)} ></i></div> :
																	(eachFarm.correctiveActions.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachFarm.correctiveActions)} onClick={() => displayScorePercent(eachFarm.correctiveActions)} ></i></div> :
																		(eachFarm.correctiveActions.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachFarm.correctiveActions)} onClick={() => displayScorePercent(eachFarm.correctiveActions)} ></i></div> : <div className="col" />
																}
															</div>
														))}

													</>
												);
											}
										}
									}) : null
								}
								<br />
							</>
						);
					}) : <> </>
				}
				<br />
				<br />
				{(supplierAnalyticsFound && supplierAnalytics && supplierAnalytics.supplierAssessments && supplierAnalytics.supplierAssessments.length > 0) ?
					supplierAnalytics.supplierAssessments.map((eachSupplierAssessment, supplierAssessIndx) => {
						matchFound = false;
						return (
							<>
								<div className="row">
									<div className="col text-start">
										<span style={{ fontWeight: "bold", fontSize: "18px" }}>{t("page.company.name")} : </span>{eachSupplierAssessment.companyName}
									</div>
								</div>
								<div className="row" >
									<div className="row-with-indicator">
									</div>
								</div>
								<div className="row">
									<div className="col text-start padd-tb10">
										<span style={{ fontWeight: "bold", fontSize: "15px" }}>{t("header.supply-chain")} </span>
									</div>
								</div>
								{supplierCountArr.length > 0 ?
									supplierCountArr.map((eachSupplierCount, supplierCountIndex) => {
										if (!matchFound) {
											if (supplierCountIndex === supplierAssessIndx) {
												matchFound = true;
											}
											if (matchFound) {
												return (
													<>
														<div className="row">
															<div className="col">
																<div className="box-container">
																	<Box id="box7" className="box box-content1">{eachSupplierCount.supplierCount}<br></br> {t("page.supplier")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box8" className="box box-content1">{eachSupplierCount.farmAnnualAssessCount}<br></br> {t("page.farm.annual.assessments")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box8" className="box box-content1">{eachSupplierCount.facilityAnnualAssessCount}<br></br> {t("page.facility.annual.assessments")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box5" className="box box-content1">{eachSupplierCount.finishedProductAssessmentsCount}<br></br> {t("page.finished.product.assessments")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box6" className="box box-content1">{eachSupplierCount.correctiveActionCount}<br></br> {t("page.corr.action")}</Box>
																	<i class="fa fa-arrow-right fa-2x" style={{ color: "#C0C0C0" }} ></i>
																	<Box id="box11" className="box box-content1">{eachSupplierCount.shipmentAssessCount}<br></br> {t("page.shipment.assessments")}</Box>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="row-with-indicator padd-tb10">
															</div>
														</div>
														<div className="row" >
															<div className="row-with-indicator">
															</div>
														</div>
														{eachSupplierAssessment.suppliers.map(eachSupplier => (
															<div className="row padd-t10">
																<div className="col">
																	<span style={{ fontSize: "18px" }}>{eachSupplier.supplierName}</span>
																</div>
																{(eachSupplier.farmAnnualAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> :
																	(eachSupplier.farmAnnualAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> :
																		(eachSupplier.farmAnnualAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.farmAnnualAssessments)} ></i></div> : <div className="col" />
																}
																{(eachSupplier.facilityAnnualAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> :
																	(eachSupplier.facilityAnnualAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> :
																		(eachSupplier.facilityAnnualAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} onClick={() => displayScorePercent(eachSupplier.facilityAnnualAssessments)} ></i></div> : <div className="col" />
																}
																{(eachSupplier.finishedProductAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> :
																	(eachSupplier.finishedProductAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> :
																		(eachSupplier.finishedProductAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.finishedProductAssessments)} onClick={() => displayScorePercent(eachSupplier.finishedProductAssessments)} ></i></div> : <div className="col" />
																}
																{(eachSupplier.correctiveActions.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> :
																	(eachSupplier.correctiveActions.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> :
																		(eachSupplier.correctiveActions.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.correctiveActions)} onClick={() => displayScorePercent(eachSupplier.correctiveActions)} ></i></div> : <div className="col" />
																}
																{(eachSupplier.shipmentAssessments.scoreToDisplay === "H") ?
																	<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "orange" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> :
																	(eachSupplier.shipmentAssessments.scoreToDisplay === "M") ?
																		<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "yellow" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> :
																		(eachSupplier.shipmentAssessments.scoreToDisplay === "L") ?
																			<div className="col padd-0"><i class="fa fa-star fa-lg" style={{ color: "green" }} onMouseOver={() => displayScorePercent(eachSupplier.shipmentAssessments)} onClick={() => displayScorePercent(eachSupplier.shipmentAssessments)} ></i></div> : <div className="col" />
																}
															</div>
														))}

													</>
												);
											}
										}
									}) : null
								}
								<br />
							</>
						);
					}) : <> </>
				}
				{showScorePopup ? <DisplayScorePercent assessment={popupAssessment} handleClose={handleClose} /> : <></>}
				<div className="row">
					<div className="col">
						<div style={{ "display": "inline-block" }}>
							{(dataFound && delegates && delegates.length > 0) ?
								<button
									className="btn btn-primary btn-block search-button"
									onClick={onClickNext}
								>
									<span class="fa fa-solid fa-chevron-right fa-2">{' '}</span>{t("page.next")}
								</button> :
								<div> </div>
							}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<div
							id="berrorMessage"
							className={
								(errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
							}
						>
							{(errorValue && errorValue.length > 0) ? (
								errorValue.map((errorData) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
						</div>
					</div>
				</div>
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default AnalyticsLanding;